import request from '../utils/request'
import qs from 'qs'
import { getTeamCode } from '@/utils/auth'
import { commonConfig } from '../utils/config'
const { apiHetaoDomain } = commonConfig

// 团队报表获取表头
export async function getTableTitle (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/team/title?teamCode=${teamCode}`)
}

// 成员报表获取表头
export async function getTableTitleNew (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/members/forms/title?teamCode=${teamCode}`)
}

// 成员报表获取表头【累计】
export async function getTableTitleSum (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/members/forms/sum/title?teamCode=${teamCode}`)
}

// 团队报表获取表头
export async function getOrgTableTitleNew (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/forms/title?teamCode=${teamCode}`)
}

// 团队报表获取表头【累计】
export async function getOrgTableTitleSum (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/forms/sum/title?teamCode=${teamCode}`)
}

// 推广链接报表获取表头【累计】
export async function getLinkTableTitleSum (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/links/forms/sum/title?teamCode=${teamCode}`)
}

// 推广链接报表获取表头
export async function getLinkTableTitleNew (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/links/forms/title?teamCode=${teamCode}`)
}

// 链接报表获取表头
export async function getLinkTableTitle (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/link/title?teamCode=${teamCode}`)
}

export async function getOrderList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/order/list?${qs.stringify(params)}`)
}

// 繁星-用户端-获取成员报表-条数(报表第一行)
export async function getOrgTableNum (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/members/forms/num?${qs.stringify(params)}`)
}

// 成员累计
export async function getOrgTableAcc (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/members/forms/sum?${qs.stringify(params)}`)
}

// 成员列表
export async function getOrgTable (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/members/forms?${qs.stringify(params)}`)
}

// 繁星-用户端-获取团队报表-条数(报表第一行)
export async function getTeamsTableNum (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/forms/num?${qs.stringify(params)}`)
}

// 团队累计
export async function getTeamsTableAcc (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/forms/sum?${qs.stringify(params)}`)
}

// 团队列表
export async function getTeamsTable (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/forms?${qs.stringify(params)}`)
}

// 繁星-用户端-获取推广链接报表-条数(报表第一行)
export async function getLinkTableNum (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/links/forms/num?${qs.stringify(params)}`)
}

// 推广链接累计
export async function getLinkTableAcc (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/links/forms/sum?${qs.stringify(params)}`)
}

// 推广链接列表
export async function getLinkTable (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/links/forms?${qs.stringify(params)}`)
}

// 团队累计(旧)
export async function getOrgListAcc (params) {
  // return request(`https://dselect.testing1.hetao101.com/post/starTimeTeamAcc`, params)
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/teamAcc`, params)
}

// 团队列表
export async function getOrgList (params) {
  // return request(`https://dselect.testing1.hetao101.com/post/starTimeTeam`, params)
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/team`, params)
}

// 推广链接累计
export async function getOrgLinkAcc (params) {
  // return request(`https://dselect.testing1.hetao101.com/post/starTimeLinkAcc`, params)
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/linkAcc`, params)
}

// 推广链接列表
export async function getOrgLinkList (params) {
  // return request(`https://dselect.testing1.hetao101.com/post/starTimeLink`, params)
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/time/link`, params)
}

export async function getChannelData (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teamChannel`, params)
}

export async function getCourseList () {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/course/team/list?teamCode=${getTeamCode()}`)
}

export async function getChannelList (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/channel/list?teamCode=${teamCode}`)
}

export async function getTermList () {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/term/list`)
}

export async function getOrgChart (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/team/table`, params)
}

export async function getChannelChart (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teamChannel/table`, params)
}

export async function queryProduct (name) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/product?name=${name}`)
}

export async function queryAuthorName (name) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/author-name?name=${name}`)
}

// 订单维度报表 - 获取表头
export async function getOrderFormTitle(teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/order/forms/title?teamCode=${teamCode}`)
}

// 订单维度报表 - 分页列表
export async function getOrderFormList(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/order/forms?${qs.stringify(params)}`)
}

// 订单维度报表 - 汇总统计
export async function getOrderFormNum(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/order/forms/num?${qs.stringify(params)}`)
}

// 订单维度报表 - 下载Excel
export async function downloadOrderForm(params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/star/teams/order/forms/download?${qs.stringify(params)}`, { config: { responseType: 'blob' } })
}
